export var darkTheme = {
    "color-black": "#0000",
    "color-white": "#fff",
    "base-color":"#111622"

}